import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { fetchCompetitorsForSelect } from 'partner360/services/competitorsSob/fetchCompetitorsForSelect'

import { REQUEST_COMPETITORS_FOR_SELECT } from '../constants'
import { selectCompetitorsSobState } from '../selectors/selectCompetitorsSobState'

export const requestCompetitorsForSelect = createAsyncThunk(
  REQUEST_COMPETITORS_FOR_SELECT,
  fetchCompetitorsForSelect,
  {
    condition({ partnerId, fYear, programType }, { getState }) {
      if (!partnerId || !fYear || !programType) {
        return false
      }

      const state = getState()
      const competitorsState = selectCompetitorsSobState(state)

      if (
        competitorsState.fYear === fYear &&
        competitorsState.partnerId === partnerId &&
        competitorsState.data[programType]?.length
      ) {
        return false
      }

      return true
    },
  }
)
